<template>
  <router-view> </router-view>
</template>

<script>
//import dotenv from "dotenv-webpack";
// import Header from "./components/Home/Header";
import Home from "./views/Home/Home";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "primevue/resources/themes/saga-blue/theme.css";
// import "primevue/resources/primevue.min.css";
// import "primeicons/primeicons.css";
import { Transition } from "vue";
//import "primeflex/primeflex.css";

export default {
  name: "App",
  components: { Home, Transition },
  data() {
    return {
      token: null,
    };
  },
  setup() {
    //dotenv.config();
    //console.log("process:::::",process.env);
  },
  mount() {},
  onMount() {
    const token = localStorage.getItem("user_token");
    this.token = token;
  },
  fetch() {
    //console.log("process:::::",process);
  },
};


const theme = localStorage.getItem("theme");
// import("../templates/placergroupthem.css");
switch (theme) {
  // case "Blue moon":
  //   import("../templates/blue-skin.css");
  //   break;

  // case "Dark knight":
  //   import("../templates/dark-skin.css");
  //   break;

  // case "Pink Berry":
  //   import("../templates/pink-skin.css");
  //   break;

  // case "Pitch Black":
  //   import("../templates/pitch-black.css");
  //   break;
  case "Placer Group":
    // import("../templates/placergroupthem.css");
    break;
  case "Toms Theme":
    // import("../templates/toms-sheet.css");
    break;
  
  // case "Primary theme":
  //   import("../templates/wireframe.css");
  //   break;
  default:
    // import("../templates/placergroupthem.css");
  
    break
}

</script>

<style>
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css";

@import "../templates/responsive.css"; 
@import "../templates/newstyles.css";


















</style>

<style></style>
